/**
 * Labstep
 *
 * @module prosemirror/nodes/protocol-timer
 * @desc ProtocolTimer node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'protocol_timer';

export const NodeTimer: LabstepNode = {
  key,
  spec: {
    attrs: {
      id: { default: null },
      guid: { default: null },
    },
    inline: true,
    group: 'inline',
    marks: '',
    // atom: true,
    draggable: true,
    parseDOM: [{ tag: 'span', getAttrs: getAttrsForId(key) }],
    toDOM(node: ProseMirrorNode) {
      const { id, guid } = node.attrs;
      return [
        'span',
        {
          [`data-${NodeTimer.key}-id`]: id,
          [`data-${NodeTimer.key}-guid`]: guid,
        },
      ];
    },
  },
};
